<template>
  <div id="forgotten-password-page">
      <AppHero :heading="heroHeading">
          <ForgottenPassword v-if="!formSubmitted" @hideForm="showConfirmation"/>
          <PasswordEmailConfirmation v-if="formSubmitted" />
      </AppHero>
  </div>
</template>

<script>
    import AppHero from "@/components/layout/AppHero";
    import ForgottenPassword from "./ForgottenPassword";
    import PasswordEmailConfirmation from "./PasswordEmailConfirmation";

    export default {
        name: 'ForgottenPasswordPage',
        components: {
            AppHero,
            ForgottenPassword,
            PasswordEmailConfirmation
        },
        data: function () {
            return {
                formSubmitted: false
            }
        },
        methods: {
            showConfirmation() {
                this.formSubmitted = true;
            }
        },
        computed: {
            heroHeading: function() {
                return this.formSubmitted ? 'Password Reset' : 'Forgotten your password?';
            }
        }
    }
</script>